'use client';

import { useRouter } from 'next/navigation';
import { useState, FormEvent } from 'react';
import { toast } from 'react-hot-toast';
import styles from './login.module.css';

export default function LoginPage() {
  const router = useRouter();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userName: username, pwd: password, userId: 1 }),
      });

      const data = await response.json();

      // 登录成功条件：HTTP 状态 2xx 且 data.code === 0
      if (response.ok && data?.code === 0) {
        // 从响应头中读取 token（/api/login 已把后端 Authorization 透传过来）
        const tokenFromHeader = response.headers.get('Authorization');
        // 如果你更希望从 body 里取，也可以用 data.token
        const token = tokenFromHeader || data?.token;

        if (token) {
          // 保存 token，后续请求自行从 localStorage 中读取并加到请求头
          window.localStorage.setItem('authToken', token);
        }

        toast.success('登录成功');
        // 检查是否有重定向参数
        const searchParams = new URLSearchParams(window.location.search);
        const redirect = searchParams.get('redirect') || '/';
        router.push(redirect);
        router.refresh();
      } else {
        // 统一按后端 message / msg / error 提示
        const message = data?.message || data?.msg || data?.error || '登录失败，请检查用户名和密码';
        toast.error(message);
      }
    } catch (error) {
      toast.error('登录失败，请稍后重试');
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className={styles.main} data-lk-theme="default">
      <div className={styles.loginContainer}>
        <div className={styles.header}>
          <img src="/images/livekit-meet-home.svg" alt="LiveKit Meet" width="360" height="45" />
          <h2>遥操控制端登录</h2>
        </div>
        <form className={styles.loginForm} onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label htmlFor="username">用户名</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="请输入用户名"
              required
              autoComplete="username"
              disabled={isLoading}
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="password">密码</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="请输入密码"
              required
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>
          <button
            type="submit"
            className="lk-button"
            disabled={isLoading}
            style={{ width: '100%', marginTop: '1rem' }}
          >
            {isLoading ? '登录中...' : '登录'}
          </button>
        </form>
      </div>
    </main>
  );
}

